import * as ui from "../../../app/core/ui";

var view = () => new ui.Pane({
    id: "SignaturePopup",
    header: "ViewSignature",
    width: "600",
    actions: [
        new ui.Button({
            id: "SignatureOkayButton",
            label: "Ok",
            classes: "right"
        })
    ],
    components: [
        new ui.Container({
            id: "SignatureThumbnailPreview",
            classes: "col-xs-12 mar-t-15 mar-b-9 signature-thumbnail-preview "
        }),
        new ui.Container({
            id: "PaneContainer",
            classes: "col-xs-12",
            components: [
                new ui.Container({
                    id: "FullNameContainer",
                    classes: "row",
                    components: [
                        new ui.LabelLabel({
                            bindLabel: "FullName",
                            bindValue: "FullName",
                            classes: "align-label-label"
                        })
                    ]
                }),
                new ui.Container({
                    id: "EmailContainer",
                    classes: "row",
                    components: [
                        new ui.LabelLabel({
                            bindLabel: "Email",
                            bindValue: "Email",
                            classes: "align-label-label"
                        })
                    ]
                })
            ]
        })
    ]
});

export default view;
